// extracted by mini-css-extract-plugin
export default {"urlsContainer":"ProjectUrls_urlsContainer__DQ7Oa","urlColumn":"ProjectUrls_urlColumn__4Oc8T","urlLink":"ProjectUrls_urlLink__Y9LVj","liveColumn":"ProjectUrls_liveColumn__bbcQx"};